import { render } from "./ActivityLogTab.vue?vue&type=template&id=064ffce8&scoped=true&ts=true"
import script from "./ActivityLogTab.vue?vue&type=script&lang=ts"
export * from "./ActivityLogTab.vue?vue&type=script&lang=ts"

import "./ActivityLogTab.vue?vue&type=style&index=0&id=064ffce8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064ffce8"]])

export default __exports__